/* eslint-disable prefer-const */
/* eslint-disable camelcase */
export default class {
  constructor (configurator) {
    this.configurator = configurator
    this.menge = 0
  }

  process () {
    this.updateDimensionTablePrices()
    this.updateDimensionGaragePrices()
    if (this.configurator.steps.find(s => s.type === 'dimension')) {
      this.updateDimensionPrices()
    }
    this.updateColorPrices()
    this.updatePrices()
    this.updateStandartDimPrice()

    return this
  }

  updatePrices () {
    this.configurator.steps.forEach((step) => {
      if (step.options) {
        step.options.forEach((option) => {
          this.updateOptionPrice(option)
        })
      }

      this.updateStepPrice(step)
    })

    const total = this.configurator.steps.reduce(function (price, step) {
      return price + (step.price ? step.price.total || 0 : 0)
    }, 0)

    // update zaunfelder Pfosten if using Menge
    this.updateMenge()

    this.configurator.price.total = (this.menge) + total * (this.configurator.quantity || 1)
  }

  updateColorPrices () {
    const self = this

    this.configurator.steps.filter((step) => step.type === 'color').forEach((step) => {
      if (!step.visible) {
        step.price.total = 0

        return
      }

      const selectedColor = step.colors.find(color => color.selected)
      const totalRelatedPrice = self.configurator.steps.filter((filterStep) => step.price_on_steps.indexOf(filterStep.id) !== -1)
        .reduce((totalPrice, step) => totalPrice + step.price.total, 0)

      step.price.total = (totalRelatedPrice / 100) * (selectedColor.special ? Number.parseInt(step.price_special) : step.price)
    })
  }

  updateDimensionPrices () {
    const step = this.configurator.steps.find(s => s.model_step)
    // eslint-disable-next-line prefer-const
    let option = step.options.find(o => o.selected)
    // eslint-disable-next-line prefer-const
    let markup = (step && typeof step.markup !== 'undefined') ? step.markup / 100 : 0

    if (option && typeof option.standart_dim !== 'undefined') {
      let standart = option.standart_dim.find(o => o.selected)
      let special = option.special_dim.find(s => s.selected)
      let tax = 19 / 100
      if (special && typeof special !== 'undefined') {
        let markup_percent = (option && option.markup) ? special.price * (Number.parseInt(option.markup) / 100) : special.price * markup;
        let price_markup = special.price + markup_percent;
        let price_tax = price_markup * tax;
        let total = price_markup + price_tax;
        // let price_discount = total * discounted;
        option.price.self = total;
        option.price.total = step.visible ? option.price.self : 0;
      } else {
        if (standart && typeof standart !== 'undefined') {
          let markup_percent = (option && option.markup) ? standart.price * (Number.parseInt(option.markup) / 100) : standart.price * markup;
          // calculate
          let price_markup = standart.price + markup_percent;
          let price_tax = price_markup * tax;
          let total = price_markup + price_tax;
          // let price_discount = total * discounted;
          option.price.self = total;
          option.price.total = step.visible ? option.price.self : 0;
        }
      }
    }
  }

  updateStandartDimPrice () {
    const step = this.configurator.steps.find(s => s.model_step)
    if (step) {
      let option = step.options.find(o => o.selected)
      let markup = (step && typeof step.markup !== 'undefined') ? step.markup / 100 : 0
      if (option && typeof option.standart_dim !== 'undefined') {
        let dims = option.standart_dim
        let tax = 19 / 100
        let discounted = (option && typeof option.discount) ? option.discount / 100 : 0
        // calc prices
        dims.forEach(dim => {
          if (dim && dim.price) {
            let markup_percent = (option && option.markup) ? dim.price * (Number.parseInt(option.markup) / 100) : dim.price * markup;
            // calculate
            let price_markup = dim.price + markup_percent;
            let price_tax = price_markup * tax;
            let total = price_markup + price_tax;
            // let price_discount = total * discounted;
            // dim['discounted'] = total - price_discount;
            dim['total'] = total;
          }
        })
      }
    }
  }

  updateDimensionTablePrices () {
    this.configurator.steps.filter((step) => step.type === 'dimension_table').forEach((step) => {
      let option = step.options.find(option => option.selected === true)
      step.price.self = option.price.self
      step.price.total = step.visible ? step.price.self : 0
    })
  }

  updateDimensionGaragePrices () {
    this.configurator.steps.filter((step) => step.type === 'dimension_garage').forEach((step) => {
      let option = step.options.find(option => option.selected)
      let special = step.specials.filter(s => s.selected)
      let percent = 19 / 100
      if (special.length !== 0) {
        let price = special[0].price * percent
        step.price.self = special[0].price + price
        step.price.total = step.visible ? step.price.self : 0
      } else {
        let price = option.price.self * percent
        step.price.self = option.price.self + price
        step.price.total = step.visible ? step.price.self : 0
      }
    })
  }

  updateStepPrice (step) {
    if (step.price && step.options) {
      if (['simpleselect', 'conditional', 'backside', 'montage_step'].indexOf(step.type) !== -1) {
        step.price.options = step.options.reduce((price, option) => {
          return price + option.price.total
        }, 0)
        step.price.total = step.visible ? (step.price.self + step.price.options) : 0
      }
    }
  }

  updateOptionPrice (option) {
    if (option.price) {
      let quantityFactor = option.quantity_multiply ? this.configurator.quantity : 1

      if (option.type === 'count') {
        option.price.total = !option.selected || option.disabled ? 0 : option.price.self * quantityFactor * option.value
      } else if (option.group === 'zaunfelder') {
        option.price.total = 0
      } else if (option.group === 'pfosten') {
        if (!option.selected || option.disabled) {
          option.price.total = 0
        } else {
          let fance = 2
          option.price.total = option.price.self * fance
          option.quantity = this.configurator.quantity * 2
        }
      } else {
        option.price.total = !option.selected || option.disabled ? 0 : option.price.self * quantityFactor
      }
    }
  }

  updateMenge () {
    let sps = this.configurator.steps.find(step => step.name === 'Pfosten')
    if (sps) {
      let o = sps.options.find(o => o.group === 'zaunfelder')
      // let pfosten = sps.options.find(o => o.group === 'pfosten' && o.selected)

      if (o && o.selected) {
        let discount = Number.parseFloat(o.discount) / 100 * o.price.self
        let price_discounted = o.price.self - discount
        let discounted = (o.discount > 0 ? price_discounted : o.price.self)
        let quantity = (this.configurator.quantity > 1 ? this.configurator.quantity + 1 : this.configurator.quantity)
        let total = quantity * discounted
        if (quantity > 1) {
          this.menge = total
        } else {
          this.menge = total
        }
      } else {
        this.menge = 0
      }
    }
  }
}
